import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import Address from '../address/Address';
import { OwnershipType } from '../global/OwnershipType.enum';
import { PropertyType } from '../global/PropertyType.enum';
import { TransactionType } from '../global/TransactionType.enum';
import type { ITicketLoanSecuritySplit } from './TicketLoanSecuritySplit.interface';

export default class TicketLoanSecuritySplit implements ITicketLoanSecuritySplit {
  id: string;
  address: Address;
  value: number;
  ownershipType: OwnershipType;
  securityType: PropertyType;
  transactionType: TransactionType;

  getAddress() {
    return Address.getAddress(this?.address);
  }

  static build = (data: ITicketLoanSecuritySplit) => new TicketLoanSecuritySplit(data);
  static blank = () => new TicketLoanSecuritySplit({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketLoanSecuritySplit} data
   */
  constructor(data?: ITicketLoanSecuritySplit, type) {
    this.id = toUUID(data?.id) || uuid();
    this.address = new Address(data?.address);
    this.value = parseFloat(data?.value || 0);
    this.ownershipType = OwnershipType.of(
      data?.ownershipType?.name || data?.ownershipType?.toString()
    );
    this.securityType =
      type === 'homeLoan'
        ? PropertyType.of(data?.securityType?.name || data?.securityType?.toString())
        : PropertyType.of(data?.securityType?.name || `p${data?.securityType}`);
    this.transactionType = TransactionType.of(
      data?.transactionType?.name || data?.transactionType?.toString()
    );
  }
}
